var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _rect9, _polygon, _rect10, _rect11, _rect12, _rect13, _polygon2, _rect14, _rect15, _rect16, _rect17, _polygon3, _rect18, _rect19, _polygon4, _rect20, _rect21, _rect22, _polygon5, _polygon6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon7, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _path26, _path27, _circle, _circle2, _path28, _rect23, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg401(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M807.49,392.36C696.35,599.57,525,622.29,525,622.29a808.72,808.72,0,0,1-83.42,10.39c-1.77.14-3.54.25-5.32.35-177.73,11.17-279.17-50-335.5-110.84C42.59,459.38,17.84,372.07,36.77,288.61,69.14,145.9,206.88,99.87,206.88,99.87c29.79-11.8,62-16.42,93.07-16.9,82.45-1.31,156.85,26.48,156.85,26.48a636.87,636.87,0,0,0,66.86,19c46.05,10.16,67.93,8,67.93,8,80.93-13.14,136.18-.12,136.18-.12C806.49,153,829.88,212,834.42,264,838.3,308.46,828.57,353.06,807.49,392.36Z",
    fill: "#00c099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M807.48,392.36c-99.23,185-246.5,222.95-276.92,229-3.65.72-5.62,1-5.62,1q-10.89,1.91-21.46,3.5l-.77.11q-32,4.79-61.18,6.78c-1.77.13-3.55.25-5.32.34q-18.81,1.19-36.48,1.31h-.79q-16.56.12-32.15-.63c-47.54-2.25-88.49-10.19-123.74-21.82a354.91,354.91,0,0,1-68.66-30.78c-.32-.16-.63-.35-.95-.55-2.66-1.55-5.3-3.16-7.87-4.77a318.22,318.22,0,0,1-64.87-53.6C42.58,459.38,17.84,372.07,36.76,288.61,69.13,145.9,206.87,99.88,206.87,99.88c29.8-11.8,62-16.43,93.08-16.91,82.45-1.31,156.84,26.49,156.84,26.49a639.65,639.65,0,0,0,66.86,18.94c46.06,10.16,67.93,8,67.93,8,80.93-13.14,136.19-.11,136.19-.11C806.49,153,829.87,212,834.41,264,838.29,308.47,828.56,353.06,807.48,392.36Z",
    fill: "#fff",
    opacity: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 559.43,
    width: 741.34,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179.49,
    y: 571.87,
    width: 49.11,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 260.73,
    y: 582.56,
    width: 44.73,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.33,
    y: 585.63,
    width: 56.71,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 706.53,
    y: 584.83,
    width: 23.57,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 643.47,
    y: 584.83,
    width: 58.3,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 433.71,
    y: 571.68,
    width: 44.97,
    height: 0.37,
    fill: "#ebebeb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 485.12,
    y: 571.68,
    width: 106.9,
    height: 0.37,
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M414.44,493.3H128.15a8.46,8.46,0,0,1-8.45-8.46V82.39A8.47,8.47,0,0,1,128.15,74H414.44a8.47,8.47,0,0,1,8.47,8.47h0V484.84A8.47,8.47,0,0,1,414.44,493.3ZM128.15,74.3a8.09,8.09,0,0,0-8.08,8.09V484.84a8.09,8.09,0,0,0,8.08,8.09H414.44a8.1,8.1,0,0,0,8.09-8.09V82.39a8.09,8.09,0,0,0-8.09-8.09Z",
    fill: "#ebebeb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M735.16,493.3H448.85a8.47,8.47,0,0,1-8.46-8.46V82.39A8.48,8.48,0,0,1,448.85,74H735.16a8.47,8.47,0,0,1,8.43,8.39V484.84A8.46,8.46,0,0,1,735.16,493.3ZM448.85,74.3a8.09,8.09,0,0,0-8.09,8.09V484.84a8.11,8.11,0,0,0,8.09,8.09H735.16a8.1,8.1,0,0,0,8.09-8.09V82.39a8.09,8.09,0,0,0-8.09-8.09Z",
    fill: "#ebebeb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 435.47,
    y: 419.77,
    width: 296.05,
    height: 32.13,
    transform: "translate(-137.28 540.25) rotate(-45)",
    fill: "#ebebeb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "599.67 442.37 576.96 419.64 545.98 450.62 566.82 483.84 599.67 442.37",
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 450.62,
    y: 445.63,
    width: 296.05,
    height: 10.7,
    transform: "translate(-143.55 555.39) rotate(-45)",
    fill: "#e0e0e0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 567.44,
    y: 295.37,
    width: 32.13,
    height: 296.05,
    transform: "translate(-142.62 542.47) rotate(-45)",
    fill: "#ebebeb"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 593.29,
    y: 280.23,
    width: 10.7,
    height: 296.05,
    transform: "translate(-127.48 548.74) rotate(-45)",
    fill: "#e0e0e0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 118.79,
    y: 450.74,
    width: 230.41,
    height: 25.01,
    transform: "translate(-259.03 301.14) rotate(-45)",
    fill: "#ebebeb"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.57 468.32 228.88 450.65 204.79 474.75 220.99 500.6 246.57 468.32",
    fill: "#e0e0e0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 130.56,
    y: 470.86,
    width: 230.41,
    height: 8.33,
    transform: "translate(-263.91 312.92) rotate(-45)",
    fill: "#e0e0e0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 221.49,
    y: 353.93,
    width: 25.01,
    height: 230.41,
    transform: "translate(-263.19 302.87) rotate(-45)",
    fill: "#ebebeb"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 241.59,
    y: 342.13,
    width: 8.33,
    height: 230.41,
    transform: "translate(-251.4 307.73) rotate(-45)",
    fill: "#e0e0e0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 509.72,
    y: 400.35,
    width: 26.11,
    height: 159.06,
    fill: "#f5f5f5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "535.83 466.45 509.72 466.45 509.72 485.53 535.83 479.9 535.83 466.45",
    fill: "#ebebeb"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 535.81,
    y: 400.37,
    width: 8.7,
    height: 159.06,
    fill: "#ebebeb"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 236.21,
    y: 400.35,
    width: 26.11,
    height: 159.06,
    fill: "#f5f5f5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.3 466.45 236.21 466.45 236.21 485.53 262.3 479.9 262.3 466.45",
    fill: "#ebebeb"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 400.37,
    width: 8.7,
    height: 159.06,
    fill: "#ebebeb"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 216.29,
    y: 423.68,
    width: 333.23,
    height: 48.96,
    fill: "#f5f5f5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 549.53,
    y: 423.66,
    width: 4.89,
    height: 48.96,
    fill: "#ebebeb"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.94 373.75 357.79 373.75 311.72 419.82 311.72 484.97 357.79 531.04 422.94 531.04 469 484.97 469 419.82 422.94 373.75",
    fill: "#fafafa"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.95 380.94 360.77 380.94 318.91 422.8 318.91 481.99 360.77 523.85 419.95 523.85 461.81 481.99 461.81 422.8 419.95 380.94",
    fill: "#e0e0e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M333.17,459.23l8.34-.74a11.84,11.84,0,0,0,1.09,4.45,4.25,4.25,0,0,0,3.87,2.44,3.5,3.5,0,0,0,3-1.24,4.46,4.46,0,0,0,1-3,4.41,4.41,0,0,0-1-2.81A9.71,9.71,0,0,0,345,456a16.81,16.81,0,0,1-8.22-4.89,11.92,11.92,0,0,1-2.48-7.8,13.82,13.82,0,0,1,1.27-5.93,9.73,9.73,0,0,1,3.81-4.34,13,13,0,0,1,7-1.59,11.17,11.17,0,0,1,8.29,2.88c1.9,1.91,3,5,3.4,9.14l-8.26.7a7.65,7.65,0,0,0-1.38-4,3.64,3.64,0,0,0-3-1.23,2.84,2.84,0,0,0-2.3.92,3.31,3.31,0,0,0-.77,2.24,2.62,2.62,0,0,0,.63,1.73,6.11,6.11,0,0,0,3,1.48,29.5,29.5,0,0,1,8.23,3.56,10.63,10.63,0,0,1,3.62,4.45,15.07,15.07,0,0,1,1.12,5.93,16.8,16.8,0,0,1-1.48,7.15,11.26,11.26,0,0,1-4.23,5,12.61,12.61,0,0,1-6.82,1.69q-7.21,0-10-4A18.94,18.94,0,0,1,333.17,459.23Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.31,432.22H388v10h-8.89v30.38h-8.77V442.19h-8.89Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M389.44,452.43q0-9.89,3.87-15.4A13.49,13.49,0,0,1,415,437q3.9,5.4,3.9,15.13a33.87,33.87,0,0,1-1.68,11.61,15.61,15.61,0,0,1-4.83,7.05,12.33,12.33,0,0,1-7.87,2.52,13.61,13.61,0,0,1-7.94-2.18,15.06,15.06,0,0,1-5.1-6.88A31.16,31.16,0,0,1,389.44,452.43Zm8.76,0q0,6.12,1.61,8.77a4.9,4.9,0,0,0,6.62,2.09,5,5,0,0,0,2.08-2.09c1-1.75,1.48-4.88,1.48-9.38a16.57,16.57,0,0,0-1.6-8.34,5,5,0,0,0-4.45-2.62,4.8,4.8,0,0,0-4.25,2.67q-1.49,2.79-1.49,9Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423.5,432.22h14.56a8.28,8.28,0,0,1,7.13,3.23,15.26,15.26,0,0,1,2.36,9.16,15.61,15.61,0,0,1-2.58,9.55,9.19,9.19,0,0,1-7.88,3.44h-4.86v15h-8.79Zm8.73,17.21h2.15a4.36,4.36,0,0,0,3.56-1.26,4.87,4.87,0,0,0,1-3.2,5.56,5.56,0,0,0-.8-3.26,3.7,3.7,0,0,0-3.33-1.32h-2.6Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M530.56,621.32c-3.65.72-5.62,1-5.62,1a811.65,811.65,0,0,1-83.41,10.39c-1.77.13-3.55.25-5.32.34a629.36,629.36,0,0,1-69.42.68c.12-21.63,1.82-38.31,5.69-47.43,24.62-58,50.45-71.84,50.45-71.84l78.22,9.27S509.22,526.55,530.56,621.32Z",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M393,582.7a50,50,0,0,1-17.51-3.2l.3-.71c.32.13,31.47,12.94,48.31-14.2,17-27.37,21.91-42.8,22-43l.74.23c-.05.15-5,15.67-22,43.13C415.93,579.22,403.27,582.7,393,582.7Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M522.32,598.73c-3.39,0-12-.59-26.27-5.34-18.72-6.24-16-67.12-15.87-69.7l.78,0c0,.63-2.83,62.88,15.34,68.93,18.33,6.11,27.48,5.25,27.57,5.24l.08.77A14.56,14.56,0,0,1,522.32,598.73Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M503.48,625.8l-.77.11-6.88-32.6,0-.21.76-.16.14.66Z",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.73 634.34 398.94 634.34 394.43 582.68 394.38 582.05 395.16 581.99 395.22 582.64 399.73 634.34",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M501.15,524.73l-80.21-8.19s-57.26,51.61-52.95,99Z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M581.62,485.83c-1.71-101.32-68.41-215.41-68.41-215.41l-.05.12c-1.27-2.51-21-26.25-40.55-22.46-60.94,11.82-173.22,176.25-193.82,200.2-2.67,3.09,95.84,84.46,223.36,57.6C554.49,494.86,581.62,489.23,581.62,485.83Z",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M499.44,261c-2.46-1.63-5.73-1.63-8.55-1.32a56.08,56.08,0,0,0-13.38,3.52c-13.6,5.07-26.39,12.37-38.72,19.95a582,582,0,0,0-50.38,35.11q-29.21,22.5-56.26,47.61c-19.79,18.31-38.73,37.55-56.61,57.73q-3.36,3.8-6.66,7.63c-.84,1,.58,2.41,1.43,1.43a800.31,800.31,0,0,1,55.93-58.5q27-25.54,56.12-48.64a625,625,0,0,1,51.05-36.62c12.84-8.19,26.12-16.07,40.19-22a78.78,78.78,0,0,1,14.32-4.73c3-.62,6.33-1,9.16-.1a5.11,5.11,0,0,1,1.34.66c1.08.72,2.09-1,1-1.74Z",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M455.08,320.72s-5.46,51.54-6.1,55.6c0,0,23.09,24.29,45.47,1.86,0,0-3.78-12.25-10.67-43.77Z",
    fill: "#f9b499"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M485.69,331.28c-.28,6.85-10,14.77-16.39,14.9-7.77.16-14.12-12.27-14.7-17.87-.48-4.72,11.62-10.14,18-9.88S486,324.44,485.69,331.28Z",
    fill: "#f7a48b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M442.89,302.85l8.88-.63.7,9.9-8.88.62a4.94,4.94,0,0,1-5.29-4.59h0A5,5,0,0,1,442.89,302.85Z",
    fill: "#f9b499"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M442.73,305.51l3.66-.26.29,4.08-3.66.26a2,2,0,0,1-2.19-1.9h0A2,2,0,0,1,442.73,305.51Z",
    fill: "#f7a48b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M503.26,309l-8.88-.55.61-9.9,8.87.55a5,5,0,0,1,4.65,5.25h0A5,5,0,0,1,503.26,309Z",
    fill: "#f9b499"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M503.82,301.86l-3.66-.28-.32,4.08,3.66.29a2.06,2.06,0,0,0,2.2-1.89h0A2,2,0,0,0,503.82,301.86Z",
    fill: "#f7a48b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M476.33,274.33h0c16.49,1.05,26.45,15.47,25.4,32l-.08,1.26c-1,16.48-15,30.38-28.86,29.27l-.12,0c-10.92-1.39-28.86-16.8-27.81-33.29l.08-1.26A29.56,29.56,0,0,1,476.33,274.33Z",
    fill: "#f9b499"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M459.22,275c34.39,13.8,43.87,24.63,43.87,24.63s1.48-39.16-40.52-33.05C435.43,270.56,457.12,274.2,459.22,275Z",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M462.71,273.93s-9.17,19.33-11.74,22.8c-2.94,4-9.11,1-9.11,1S439,270.53,462.71,273.93Z",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M494.45,378.18,563,396.58l12.81,36.54a20.89,20.89,0,0,1-19.72,27.8H521.74s-7.21,47.86-7.21,66.39L405.62,513.23l1.87-77S339.57,463,312.81,458.86c0,0-30.88-18.52-13.38-42.19,0,0,126.08-51.62,145.38-46.91,0,0,11.06,17.06,27.53,17.06S494.45,378.18,494.45,378.18Z",
    fill: "#00c099"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.88,369.61s6.84,23.78,40.3,28c32.89,4.11,38.65-15.63,38.65-15.63",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.21,
    y1: 495.44,
    x2: 515.41,
    y2: 507.78,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.27
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "407.49 436.22 514.53 527.31 405.62 513.23 407.49 436.22",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M544.27,479.06h0A30.07,30.07,0,0,1,520,439.66l13.55-40.09L578.41,406l.18,43.21A30.08,30.08,0,0,1,544.27,479.06Z",
    fill: "#f7a48b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M532.19,439.18s-29-38.17-23.78-39.79c3.38-1,12.43,4.05,18.44,7.8,2.7,1.69,6.22-.29,6.64-3.73,1.27-10.34,3.48-29.27,4.44-43,1.38-19.79,6.79-20.54,10.3,13.15s5.47-29.07,9.81-28.45,2.69,35.55,6.29,37.65,4.29-33.47,11.3-34.66.67,34.65,2.41,36.72,6.28-23,9.22-22.85c10.36.43-7.94,75.75-10.21,80.55,0,0,0,0,0,0s-6.4,10.58-24.93,8.53C552.1,451.15,540.45,451.14,532.19,439.18Z",
    fill: "#f9b499"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M409.09,390.39c-1.32,0-2.43-2.75-2.59-6.39L399,215c-.18-4,.85-7.66,2.29-8.14s2.76,2.36,2.93,6.37l7.42,169.07c.18,4-.82,7.59-2.25,8.1h0Z",
    fill: "#e1e1e2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 403.77,
    cy: 150.17,
    r: 101.64,
    fill: "#00c099"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.74,
    cy: 150.15,
    r: 82.08,
    transform: "translate(12.08 329.47) rotate(-45)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M457.07,136.29c-6.74-9.11-19.72,0-23.61,9.57a26.16,26.16,0,0,0-2.06,7.47l-4.28-29.23-3.39-27.71a9.23,9.23,0,0,0-18.31,2.24l-.85-6.9A9.21,9.21,0,1,0,386.28,94l1.18,9.61a9.23,9.23,0,0,0-10.29-8,8.94,8.94,0,0,0-1.15.21h0a9.26,9.26,0,0,0-6.88,10.07l1.47,12a9.2,9.2,0,0,0-10.25-8,9.43,9.43,0,0,0-1.18.22h0a9.22,9.22,0,0,0-6.87,10l2.94,24,2.1,17.18,2.78,22.57c2,16.13,8.26,25.23,17.6,29.34,14.33,6.29,40.59,6.36,52.38-3.21,10.33-8.37,17-28.53,18.55-41S459.81,140,457.07,136.29Z",
    fill: "#2f2e41"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 305.6,
    y: 139.57,
    width: 196.3,
    height: 21.24,
    transform: "translate(36.79 375.82) rotate(-51.99)",
    fill: "#00c099"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M210.85,240.86H108.69V194.74L210.85,73.31h48.84V197.45H285V241h-25.3v37.73H210.89Zm0-43.51V133.83l-54,63.52Z",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M659.09,73.31V278.59h-56.8V144.07A172.36,172.36,0,0,1,575.84,161a207.69,207.69,0,0,1-32.3,12.39v-46q28.63-9.26,44.47-22.18a90.31,90.31,0,0,0,24.78-31.93Z",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.25,287.12V255.88h22.61v3.64H113.39v9.58h17.29v3.67H113.39V283.4h19.14v3.69Z",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M137.77,287.12V264.48h3.43v3.43a9.6,9.6,0,0,1,2.44-3.18,4.32,4.32,0,0,1,2.46-.77,7.57,7.57,0,0,1,4,1.26l-1.33,3.55a5.38,5.38,0,0,0-2.81-.82,3.51,3.51,0,0,0-2.25.75,4.06,4.06,0,0,0-1.44,2.1,15.08,15.08,0,0,0-.64,4.48v11.84Z",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.31,287.12V264.48h3.44v3.43a9.44,9.44,0,0,1,2.54-3.24,4.22,4.22,0,0,1,2.45-.78,7.51,7.51,0,0,1,3.95,1.26l-1.32,3.55a5.51,5.51,0,0,0-2.82-.82,3.53,3.53,0,0,0-2.25.75,4.12,4.12,0,0,0-1.44,2.1,15.4,15.4,0,0,0-.63,4.48v11.85Z",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.46,275.81q0-6.29,3.44-9.32A10.44,10.44,0,0,1,176,264a10.16,10.16,0,0,1,7.64,3.08,11.66,11.66,0,0,1,3,8.44,15,15,0,0,1-1.33,6.87,9.2,9.2,0,0,1-3.81,3.88,11,11,0,0,1-5.47,1.39,10.18,10.18,0,0,1-7.68-3A12.17,12.17,0,0,1,165.46,275.81Zm3.95,0a9.74,9.74,0,0,0,1.89,6.51,6.33,6.33,0,0,0,8.94.58,5.39,5.39,0,0,0,.59-.58,10,10,0,0,0,1.91-6.65,9.35,9.35,0,0,0-1.91-6.35,6.36,6.36,0,0,0-9-.56,5.92,5.92,0,0,0-.56.56A9.69,9.69,0,0,0,169.41,275.81Z",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M191.13,287.12V264.48h3.44v3.43a9.35,9.35,0,0,1,2.43-3.18,4.32,4.32,0,0,1,2.46-.77,7.51,7.51,0,0,1,3.95,1.26l-1.32,3.55a5.51,5.51,0,0,0-2.82-.82,3.58,3.58,0,0,0-2.27.75,4.08,4.08,0,0,0-1.42,2.1,14.76,14.76,0,0,0-.64,4.48v11.84Z",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.52,325.94v-3.33a8.33,8.33,0,0,1-7.2,3.87,9,9,0,0,1-3.72-.78,6.16,6.16,0,0,1-2.59-1.92,7.79,7.79,0,0,1-1.19-2.85,20.55,20.55,0,0,1-.22-3.59v-14h3.83v12.55a21.14,21.14,0,0,0,.24,4,4.06,4.06,0,0,0,1.53,2.39,4.83,4.83,0,0,0,2.9.86,6.36,6.36,0,0,0,3.24-.88,5.06,5.06,0,0,0,2.15-2.42,12.47,12.47,0,0,0,.62-4.41V303.3H127v22.64Z",
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M133,325.94V303.3h3.44v3.21a8.18,8.18,0,0,1,7.21-3.73,9.18,9.18,0,0,1,3.76.74,6,6,0,0,1,2.57,1.92,7.64,7.64,0,0,1,1.2,2.85,22.17,22.17,0,0,1,.21,3.73v13.92h-3.83V312.21a10,10,0,0,0-.46-3.44,3.67,3.67,0,0,0-1.58-1.85,5,5,0,0,0-2.68-.69,6.32,6.32,0,0,0-4.24,1.55c-1.19,1.05-1.72,3-1.72,5.92v12.36Z",
    fill: "#2f2e41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172,323.15a13.93,13.93,0,0,1-4.12,2.55,11.71,11.71,0,0,1-4.22.76,8.23,8.23,0,0,1-5.74-1.84,6,6,0,0,1-2-4.65,6.28,6.28,0,0,1,2.75-5.24,9.3,9.3,0,0,1,2.77-1.27,33.15,33.15,0,0,1,3.43-.57,34.89,34.89,0,0,0,6.87-1.32v-1a4.26,4.26,0,0,0-1.08-3.3,6.39,6.39,0,0,0-4.38-1.3,6.9,6.9,0,0,0-4,.94,5.82,5.82,0,0,0-1.91,3.44l-3.74-.52a8.89,8.89,0,0,1,1.72-3.88,7.2,7.2,0,0,1,3.43-2.28,15,15,0,0,1,5.15-.81,13.51,13.51,0,0,1,4.72.69,6.17,6.17,0,0,1,2.66,1.71,5.94,5.94,0,0,1,1.2,2.61,22.12,22.12,0,0,1,.19,3.54v5.15a60.59,60.59,0,0,0,.24,6.87,9,9,0,0,0,1,2.71h-4A8.22,8.22,0,0,1,172,323.15Zm-.32-8.59a28.11,28.11,0,0,1-6.27,1.44,14.35,14.35,0,0,0-3.43.78,3.32,3.32,0,0,0-1.52,1.25,3.25,3.25,0,0,0-.53,1.82,3.31,3.31,0,0,0,1.15,2.56,5,5,0,0,0,3.44,1,8,8,0,0,0,4-1A6,6,0,0,0,171,319.8a9.29,9.29,0,0,0,.61-3.83Z",
    fill: "#2f2e41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M196.39,325.94v-3.33a8.33,8.33,0,0,1-7.2,3.87,9.25,9.25,0,0,1-3.74-.78,6.28,6.28,0,0,1-2.58-1.92,7.23,7.23,0,0,1-1.18-2.85,19.64,19.64,0,0,1-.24-3.59v-14h3.84v12.55a22.89,22.89,0,0,0,.24,4,4.11,4.11,0,0,0,1.53,2.39,4.85,4.85,0,0,0,2.9.86,6.42,6.42,0,0,0,3.25-.88,5.11,5.11,0,0,0,2.15-2.42,12.24,12.24,0,0,0,.61-4.41V303.3h3.85v22.64Z",
    fill: "#2f2e41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M214.21,322.51l.56,3.43a13.45,13.45,0,0,1-2.9.35,6.72,6.72,0,0,1-3.24-.66,3.7,3.7,0,0,1-1.63-1.71,13.79,13.79,0,0,1-.47-4.52v-13h-2.81V303.3h2.81v-5.62l3.81-2.3v7.92h3.87v3h-3.87v13.33a6.83,6.83,0,0,0,.21,2.11,1.6,1.6,0,0,0,.67.74,2.56,2.56,0,0,0,1.3.29A12.06,12.06,0,0,0,214.21,322.51Z",
    fill: "#2f2e41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M218,325.94V294.68h3.84v11.19a8.58,8.58,0,0,1,6.79-3.1,9,9,0,0,1,4.37,1,5.87,5.87,0,0,1,2.66,2.73,12.56,12.56,0,0,1,.79,5.15V326H232.6V311.64a6,6,0,0,0-1.26-4.19,4.62,4.62,0,0,0-3.53-1.3,6.4,6.4,0,0,0-3.22.87,5,5,0,0,0-2.12,2.41,11,11,0,0,0-.66,4.17V326Z",
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.82,314.61q0-6.28,3.43-9.3a10.51,10.51,0,0,1,7.13-2.53,10.23,10.23,0,0,1,7.69,3.09,11.67,11.67,0,0,1,3,8.47,15.11,15.11,0,0,1-1.3,6.86,9.24,9.24,0,0,1-3.83,3.9,11,11,0,0,1-5.46,1.39,10.16,10.16,0,0,1-7.69-3.05A12.17,12.17,0,0,1,240.82,314.61Zm4,0a9.68,9.68,0,0,0,1.89,6.53,6.12,6.12,0,0,0,4.79,2.16,6,6,0,0,0,4.75-2.18,9.83,9.83,0,0,0,1.89-6.63,9.36,9.36,0,0,0-1.9-6.37,6.34,6.34,0,0,0-8.94-.59,6.57,6.57,0,0,0-.59.59,9.56,9.56,0,0,0-1.89,6.49Z",
    fill: "#2f2e41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M266.45,325.94V303.3h3.44v3.43a9.25,9.25,0,0,1,2.44-3.18,4.26,4.26,0,0,1,2.45-.77,7.49,7.49,0,0,1,4,1.24l-1.32,3.57a5.32,5.32,0,0,0-2.82-.84,3.67,3.67,0,0,0-2.25.75,4.26,4.26,0,0,0-1.44,2.1,15.4,15.4,0,0,0-.63,4.48v11.86Z",
    fill: "#2f2e41"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M281.1,299.09v-4.41h3.84v4.41Zm0,26.85V303.3h3.84v22.64Z",
    fill: "#2f2e41"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M288.77,325.94v-3.1l14.43-16.56c-1.72,0-3.09.12-4.33.12h-9.24v-3.1h18.51v2.57l-12.26,14.37-2.37,2.63c1.72-.14,3.33-.21,4.84-.21h10.48V326Z",
    fill: "#2f2e41"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M328.13,318.65l4,.49a9.69,9.69,0,0,1-3.43,5.4,10.53,10.53,0,0,1-6.47,1.92,10.34,10.34,0,0,1-7.89-3.07,11.93,11.93,0,0,1-2.91-8.59,12.55,12.55,0,0,1,2.95-8.88,9.88,9.88,0,0,1,7.62-3.15,9.7,9.7,0,0,1,7.44,3.09,12.34,12.34,0,0,1,2.86,8.7v1H315.37a8.82,8.82,0,0,0,2.11,5.7,6.3,6.3,0,0,0,4.74,2,5.91,5.91,0,0,0,3.61-1.11A7.43,7.43,0,0,0,328.13,318.65Zm-12.61-6.2h12.64a7.69,7.69,0,0,0-1.44-4.29,5.87,5.87,0,0,0-4.76-2.22,6,6,0,0,0-4.44,1.72A7,7,0,0,0,315.52,312.45Z",
    fill: "#2f2e41"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6,325.94V323a7,7,0,0,1-6.34,3.44,9,9,0,0,1-5-1.5,9.91,9.91,0,0,1-3.52-4.17,14.43,14.43,0,0,1-1.23-6.15,16,16,0,0,1,1.13-6.16,8.73,8.73,0,0,1,3.43-4.22,9.06,9.06,0,0,1,5.05-1.48,7.65,7.65,0,0,1,3.66.86,7.89,7.89,0,0,1,2.59,2.25V294.7h3.83V326Zm-12.13-11.29a9.83,9.83,0,0,0,1.82,6.49,5.57,5.57,0,0,0,4.33,2.16,5.42,5.42,0,0,0,4.28-2.06,9.37,9.37,0,0,0,1.71-6.28,10.68,10.68,0,0,0-1.71-6.87,5.51,5.51,0,0,0-4.42-2.18,5.3,5.3,0,0,0-4.27,2.09A10.38,10.38,0,0,0,339.47,314.65Z",
    fill: "#2f2e41"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M430.31,391.38c.55-1.49,20.66-8.56,18-11.79s-21,6.65-20.93,4.21,18.31-11.65,17.39-14-33.5,14.66-17.33,3.18,14.23-14,3.74-9C424,367.36,413.66,371.68,408,374a2.64,2.64,0,0,1-3.82-2.31c.19-4.14.18-10.22-1.32-11.64-2.34-2.21-13.46,23.53-13.46,23.53v0c-6.86-.78-48.33,11.21-76,22.57-17.11,7-27.86,22.85-18.75,39l1.72,3c9.37,16.62,37.73,16.87,52.64,5.09,22-17.38,47.58-40.77,51.53-45.8h0c3.1-.23,46.77-12.55,44-18C443.83,388,429.77,392.86,430.31,391.38Z",
    fill: "#f9b499"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg401);
export default __webpack_public_path__ + "static/media/401.2e05a27ed1215f59c7610585825b18e1.svg";
export { ForwardRef as ReactComponent };